import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EndorseComponent } from './endorse/endorse.component';
import { EndorseDetailComponent } from './endorse-detail/endorse-detail.component';

const routes: Routes = [
  { path: 'avales', component: EndorseComponent},
  { path: 'avales/materias', component: EndorseDetailComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndorsesRoutingModule { }
